import { useEffect, useState } from 'react'

import { getMantenedores } from './api/apiCall';
import { formatCurrency, transformarJSON } from './genericFunctions';
import { tipoHeaders } from '../../modules/cierre/helpers/headersTablas';
import { MDBDataTable } from 'mdbreact';

const possibleTipo = [
    'banco',
    'tipo_cuenta',
    'empresa',
    'tipo_flota',
    'tms',
    'conductores',
    'centro_despacho',
    'tipo_vehiculo',
    'vehiculo',
    'tipo_documento',
    'bonos',
    'descuentos',
    'bnd',
    'rem',
    'ife',
    'ListaBonos',
    'ListaDescuentos',
    'ListaBnd',
    'ListaRem',
    'ListaIfe',
    'cierre',
]

export const Tablas = ({ tipo, user }) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            const result = await getMantenedores(tipo, user); // Espera a que la promesa se resuelva

            if (result.error) {
                setData(result); // Actualiza el estado con los datos recibidos
                setLoading(false); // Cambia el estado de carga
                return
            }
            const resultFixed = transformarJSON(result)

            resultFixed.dato = resultFixed.dato.map((item, index) => {
                if (item.monto) {
                    item.monto = formatCurrency(item.monto)
                }
                return {
                    ...item,
                    addBtn: <button key={index} className="btn btn-primary" onClick={() => useButton(item)}>Detalles</button>
                }
            })

            const tableData = {
                columns: tipoHeaders(tipo),
                rows: resultFixed.dato
            }
            setData(tableData); // Actualiza el estado con los datos recibidos
            setLoading(false); // Cambia el estado de carga
        };

        if (possibleTipo.includes(tipo)) {
            fetchData(); // Llama a la API solo si el tipo es válido
        } else {
            console.error('El tipo de tabla no existe');
            setLoading(false); // Cambia el estado de carga
        }
    }, [tipo]); // Ejecuta el efecto cuando el tipo cambia


    if (!possibleTipo.includes(tipo)) {
        return <p>El tipo de tabla no existe</p>
    }

    const useButton = (item) => {
        console.log('ID:', item.id)
        console.log('data:', item)
    }

    return (
        <>
            {
                loading
                    ? <p>Cargando...</p>
                    : data
                        ? data.error
                            ? <p>{data.error}</p>
                            : (
                                <>
                                    <MDBDataTable
                                        striped
                                        bordered
                                        small
                                        hover
                                        data={data}
                                        noBottomColumns
                                    />
                                </>
                            )
                        : <p>No hay datos</p>
            }
        </>
    )
}